/**
 * TTD Athletics — Homepage JS
 * Sticky header · Mobile nav · Testimonials slider
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    stickyHeader();
    mobileNav();
    testimonials();
  }

  /* ── Add to cart → open Broadcast's cart drawer ──────────────
     Broadcast's cart drawer adds + refreshes + opens when it
     receives a `theme:cart:add` event whose detail.button sits in
     a <form> with id + quantity. We build a tiny hidden form and
     fire that event (the exact pattern Broadcast's own buttons use).
     If the drawer isn't on the page, we fall back to a plain AJAX
     add + redirect to /cart so add-to-cart still works. */
  function ttdAddToCart(variantId, qty, onDone) {
    variantId = parseInt(variantId);
    qty = parseInt(qty) || 1;
    if (!variantId) return;
    var hasDrawer = !!document.querySelector('cart-drawer');
    if (hasDrawer) {
      var form = document.createElement('form');
      form.style.display = 'none';
      form.method = 'post';
      form.action = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
      form.innerHTML =
        '<input type="hidden" name="id" value="' + variantId + '">' +
        '<input type="hidden" name="quantity" value="' + qty + '">';
      var b = document.createElement('button');
      b.type = 'submit';
      form.appendChild(b);
      document.body.appendChild(form);
      document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: b } }));
      setTimeout(function () { form.remove(); }, 2500);
      if (onDone) onDone();
      return;
    }
    // Fallback: no drawer on page
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { if (onDone) onDone(); window.location.href = '/cart'; })
      .catch(function () { if (onDone) onDone(); });
  }
  // expose for inline section scripts (quick view)
  window.ttdAddToCart = ttdAddToCart;

  /* ── Sticky header ──────────────────────────── */
  function stickyHeader() {
    var header = document.getElementById('ttd-header');
    if (!header) return;
    function onScroll() {
      header.classList.toggle('scrolled', window.scrollY > 24);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Mobile nav ─────────────────────────────── */
  function mobileNav() {
    var burger   = document.getElementById('ttd-burger');
    var mobileNav = document.getElementById('ttd-mobile-nav');
    if (!burger || !mobileNav) return;

    burger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });

    // Close on link click
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        burger.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── Testimonials slider ────────────────────── */
  function testimonials() {
    var track   = document.getElementById('ttd-track');
    var dotsWrap = document.getElementById('ttd-dots');
    var prevBtn = document.getElementById('ttd-prev');
    var nextBtn = document.getElementById('ttd-next');
    if (!track || !dotsWrap) return;

    var slides  = track.querySelectorAll('.ttd-review');
    var total   = slides.length;
    var current = 0;
    var timer   = null;

    // Build dots
    slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'ttd-dot' + (i === 0 ? ' on' : '');
      dot.setAttribute('aria-label', 'Review ' + (i + 1));
      dot.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(dot);
    });
    var dots = dotsWrap.querySelectorAll('.ttd-dot');

    function goTo(idx) {
      current = ((idx % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('on', i === current); });
      resetAuto();
    }

    function resetAuto() {
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, 5500);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    // Touch / swipe
    var startX = 0;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 48) goTo(diff > 0 ? current + 1 : current - 1);
    });

    // Keyboard nav when focused inside
    track.closest('.ttd-reviews').addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    resetAuto();
  }

  /* ── COLLECTION PAGE ─────────────────────── */
  function collectionPage() {
    // Sort-by redirect
    var sortSel = document.querySelector('[data-ttd-sort]');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Quick add — collection cards / Pairs Well With → opens cart drawer
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var vid = parseInt(this.dataset.variantId);
        if (!vid) return;
        var orig = this.textContent;
        var self = this;
        self.disabled = true;
        self.textContent = '…';
        ttdAddToCart(vid, 1, function () {
          self.textContent = 'Added ✓';
          setTimeout(function () { self.textContent = orig; self.disabled = false; }, 1600);
        });
      });
    });
  }

  /* ── PRODUCT PAGE ─────────────────────────── */
  function productPage() {
    var prod = document.querySelector('.ttd-prod');
    if (!prod) return;

    var jsonEl = document.getElementById('ttd-product-json');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];

    // Gather initial option values per index
    var selectedOpts = {};
    prod.querySelectorAll('[data-option-index]').forEach(function (wrap) {
      var idx = parseInt(wrap.dataset.optionIndex);
      var activePrimary = wrap.querySelector('.ttd-prod__color-sw--active, .ttd-prod__size-btn--active');
      if (activePrimary) selectedOpts[idx] = activePrimary.dataset.optionValue;
    });

    function findVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return Object.keys(selectedOpts).every(function (idx) {
          return opts[parseInt(idx)] === selectedOpts[idx];
        });
      });
    }

    function updateVariantUI(v) {
      if (!v) return;
      // Hidden input
      var input = document.getElementById('ttd-variant-id');
      if (input) input.value = v.id;

      // Price
      var priceWrap = document.getElementById('ttd-price-display');
      if (priceWrap) {
        var p = (v.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        var cp = v.compare_at_price ? (v.compare_at_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : null;
        if (cp && v.compare_at_price > v.price) {
          priceWrap.innerHTML = '<s class="ttd-prod__price--compare">' + cp + '</s><span class="ttd-prod__price ttd-prod__price--sale">' + p + '</span><span class="ttd-prod__sale-badge">Sale</span>';
        } else {
          priceWrap.innerHTML = '<span class="ttd-prod__price">' + p + '</span>';
        }
        // Sticky price
        var sp = document.getElementById('ttd-sticky-price');
        if (sp) sp.textContent = p;
      }

      // Availability
      var avail = document.getElementById('ttd-avail');
      if (avail) {
        avail.innerHTML = v.available
          ? '<span class="ttd-prod__avail--in">● In Stock</span>'
          : '<span class="ttd-prod__avail--out">● Out of Stock</span>';
      }

      // ATC button
      var btn = document.getElementById('ttd-atc-btn');
      var stickyBtn = document.getElementById('ttd-sticky-btn');
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      }
      if (stickyBtn) {
        stickyBtn.disabled = !v.available;
        stickyBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      }
    }

    // Option button clicks
    prod.querySelectorAll('.ttd-prod__color-sw, .ttd-prod__size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(this.dataset.optionIndex);
        selectedOpts[idx] = this.dataset.optionValue;

        // Toggle active class within this option group
        var group = prod.querySelector('[data-option-index="' + idx + '"]');
        if (group) {
          group.querySelectorAll('.ttd-prod__color-sw, .ttd-prod__size-btn').forEach(function (b) {
            b.classList.remove('ttd-prod__color-sw--active', 'ttd-prod__size-btn--active');
          });
        }
        this.classList.add(
          this.classList.contains('ttd-prod__color-sw') ? 'ttd-prod__color-sw--active' : 'ttd-prod__size-btn--active'
        );

        // Update color label
        if (this.classList.contains('ttd-prod__color-sw')) {
          var lbl = document.getElementById('ttd-color-val');
          if (lbl) lbl.textContent = this.dataset.optionValue;
        } else {
          var slbl = document.getElementById('ttd-size-val');
          if (slbl) slbl.textContent = this.dataset.optionValue;
        }

        updateVariantUI(findVariant());
      });
    });

    // Gallery thumbnails — show/hide slides by index
    var slides = document.querySelectorAll('.ttd-prod__media-slide');
    document.querySelectorAll('.product__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(this.dataset.index, 10);

        // Hide all slides, show target
        slides.forEach(function (s) { s.style.display = 'none'; s.classList.remove('active'); });
        if (slides[index]) { slides[index].style.display = 'block'; slides[index].classList.add('active'); }

        // Update active thumb
        document.querySelectorAll('.product__thumb').forEach(function (t) {
          t.classList.remove('active', 'ttd-prod__thumb--active');
        });
        this.classList.add('active', 'ttd-prod__thumb--active');

        // Keep product-main-image class on visible slide for swatch JS compatibility
        document.querySelectorAll('.ttd-prod__gallery-img').forEach(function (img) {
          img.classList.remove('product-main-image');
        });
        if (slides[index]) {
          var visibleImg = slides[index].querySelector('img');
          if (visibleImg) visibleImg.classList.add('product-main-image');
        }
      });
    });

    // Quantity controls
    var qtyInput = document.getElementById('ttd-qty');
    document.querySelectorAll('[data-prod-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1);
      });
    });
    document.querySelectorAll('[data-prod-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (qtyInput) qtyInput.value = parseInt(qtyInput.value) + 1;
      });
    });

    // ATC form — AJAX
    var form = document.getElementById('ttd-atc-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var vid = parseInt(document.getElementById('ttd-variant-id').value);
        var qty = parseInt((document.getElementById('ttd-qty') || { value: '1' }).value) || 1;
        var btn = document.getElementById('ttd-atc-btn');
        if (!vid || (btn && btn.disabled)) return;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        ttdAddToCart(vid, qty, function () {
          btn.textContent = 'Added ✓';
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
          }, 1800);
        });
      });
    }

    // Sticky ATC — trigger on scroll past the buy controls.
    // Observe the WRAPPER, not #ttd-atc-btn: on a sold-out variant the button is
    // display:none, and an IntersectionObserver on a hidden element always reports
    // "not intersecting", which pinned the sticky bar open from page load. The
    // wrapper is always laid out and holds whichever CTA is currently showing
    // (Add to Cart or Notify Me).
    var stickyBar = document.getElementById('ttd-sticky-atc');
    var atcBtn = prod.querySelector('.ttd-prod__ctas') || document.getElementById('ttd-atc-btn');
    if (stickyBar && atcBtn) {
      var stickyObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('ttd-sticky-atc--visible', !entry.isIntersecting);
          stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      }, { rootMargin: '-100px 0px 0px 0px' });
      stickyObs.observe(atcBtn);
    }

    // Sticky ATC button click
    var stickyBtn = document.getElementById('ttd-sticky-btn');
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        // In Notify Me mode this button is not an add-to-cart any more — let the
        // document-delegated handler in snippets/ttd-notify-me.liquid open the modal.
        if (this.hasAttribute('data-ttd-notify')) return;
        form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }

    // Size guide modal
    var modal = document.getElementById('ttd-size-modal');
    document.querySelectorAll('[data-size-guide-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (modal) {
          modal.classList.add('ttd-modal--open');
          modal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        }
      });
    });
    document.querySelectorAll('[data-size-guide-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (modal) {
          modal.classList.remove('ttd-modal--open');
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('ttd-modal--open')) {
        modal.classList.remove('ttd-modal--open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });

    // Accordions
    document.querySelectorAll('[data-accord]').forEach(function (acc) {
      var btn = acc.querySelector('[data-accord-btn]');
      var body = acc.querySelector('[data-accord-body]');
      if (!btn || !body) return;
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !isOpen);
        if (isOpen) {
          body.style.maxHeight = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.maxHeight = '0'; });
          body.classList.remove('ttd-accord__body--open');
        } else {
          body.style.maxHeight = body.scrollHeight + 'px';
          body.classList.add('ttd-accord__body--open');
          var trans = function () {
            body.style.maxHeight = '';
            body.removeEventListener('transitionend', trans);
          };
          body.addEventListener('transitionend', trans);
        }
      });
    });
  }

  /* ── CART PAGE ─────────────────────────────── */
  function cartPage() {
    if (!document.querySelector('.ttd-cart-pg')) return;

    function updateCart(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    }

    function refreshCartTotals(cart) {
      var fmt = function (cents) {
        return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      };
      ['ttd-cart-subtotal', 'ttd-cart-total'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.textContent = fmt(cart.total_price);
      });
      var chkPrice = document.getElementById('ttd-checkout-price');
      if (chkPrice) chkPrice.textContent = fmt(cart.total_price);

      // Update shipping progress
      var threshold = 25000;
      var pct = Math.min((cart.total_price / threshold) * 100, 100);
      var fill = document.querySelector('.ttd-cart-pg__prog-fill');
      if (fill) fill.style.width = pct + '%';
      var msg = document.querySelector('.ttd-cart-pg__ship-msg');
      if (msg) {
        if (cart.total_price >= threshold) {
          msg.innerHTML = '🎉 You\'ve unlocked <strong>free shipping!</strong>';
          msg.classList.add('ttd-cart-pg__ship-msg--free');
        } else {
          var rem = fmt(threshold - cart.total_price);
          msg.innerHTML = 'Add <strong>' + rem + '</strong> more for <strong>free shipping</strong>';
          msg.classList.remove('ttd-cart-pg__ship-msg--free');
        }
      }

      updateCartCount(cart.item_count);
    }

    // Qty controls
    document.addEventListener('click', function (e) {
      var incBtn = e.target.closest('[data-cart-inc]');
      var decBtn = e.target.closest('[data-cart-dec]');
      var remBtn = e.target.closest('[data-remove-key]');

      if (incBtn || decBtn) {
        var ctrl = (incBtn || decBtn).closest('.ttd-qty-ctrl');
        if (!ctrl) return;
        var key = ctrl.dataset.itemKey;
        var valEl = ctrl.querySelector('[data-qty-val]');
        var currentQty = parseInt(valEl ? valEl.textContent : 1);
        var newQty = incBtn ? currentQty + 1 : Math.max(0, currentQty - 1);
        if (valEl) valEl.textContent = newQty;
        updateCart(key, newQty).then(function (cart) {
          if (newQty === 0) {
            var item = ctrl.closest('.ttd-cart-pg__item');
            if (item) item.remove();
            if (cart.item_count === 0) window.location.reload();
          }
          refreshCartTotals(cart);
        });
        return;
      }

      if (remBtn) {
        var key = remBtn.dataset.removeKey;
        var item = remBtn.closest('.ttd-cart-pg__item');
        if (item) item.style.opacity = '.4';
        updateCart(key, 0).then(function (cart) {
          if (item) item.remove();
          if (cart.item_count === 0) window.location.reload();
          refreshCartTotals(cart);
        });
      }
    });

    // Discount code — redirect to checkout with code
    var applyBtn = document.getElementById('ttd-apply-discount');
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        var code = (document.getElementById('ttd-discount-code') || {}).value;
        if (code && code.trim()) {
          window.location.href = '/checkout?discount=' + encodeURIComponent(code.trim());
        }
      });
    }
  }

  /* ── HELPER: update cart count badge ──────── */
  function updateCartCount(count) {
    if (count !== undefined) {
      document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
      return;
    }
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  /* ── INIT all page functions ──────────────── */
  collectionPage();
  productPage();
  cartPage();

  // Re-run scroll reveal for dynamically added elements
  if (typeof IntersectionObserver !== 'undefined') {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal:not(.visible)').forEach(function (el) {
      revealObs.observe(el);
    });
  }

})();

/* ============================================================
   STAGGERED CARD REVEAL — smooth scroll entrance
   ============================================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    staggeredCards();
  });

  function staggeredCards() {
    if (!window.IntersectionObserver) return;

    var grids = document.querySelectorAll('.ttd-grid, .ttd-coll__grid');

    grids.forEach(function (grid) {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.ttd-card'));
      if (!cards.length) return;

      cards.forEach(function (card) {
        card.style.opacity    = '0';
        card.style.transform  = 'translateY(20px)';
        card.style.transition = 'opacity .5s ease, transform .5s ease';
      });

      var triggered = false;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || triggered) return;
          triggered = true;
          cards.forEach(function (card, i) {
            setTimeout(function () {
              card.style.opacity   = '1';
              card.style.transform = 'translateY(0)';
            }, i * 70);
          });
          obs.disconnect();
        });
      }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

      obs.observe(grid);
    });
  }

}());

/* ============================================================
   HOMEPAGE CARD SWATCHES — image swap on click
   ============================================================ */
(function () {
  function initCardSwatches() {
    document.querySelectorAll('.card-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var imageUrl = swatch.dataset.image;
        if (!imageUrl || imageUrl === 'null' || imageUrl === '') return;

        var card = swatch.closest('.ttd-card');
        if (!card) return;

        var img = card.querySelector('.ttd-card__img-main');
        if (img) {
          img.src = imageUrl;
          img.srcset = '';
        }

        card.querySelectorAll('.card-swatch').forEach(function (s) {
          s.classList.remove('active');
        });
        swatch.classList.add('active');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardSwatches);
  } else {
    initCardSwatches();
  }
}());
/* ── YoungLA-style product cards (snippets/ttd-grid-card.liquid) ──────────
   Event-delegated so cards appended later (collection infinite scroll,
   homepage tabs) work without re-binding.
   • colour swatch  → swaps the card image + link to that colour
   • hover / "+"    → size bar for the chosen colour; a size adds straight
                      to the cart (Broadcast cart drawer via ttdAddToCart)
   • 3+ options     → "Choose options" opens the global quick view */
(function () {
  'use strict';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function data(card) {
    if (card.__gc) return card.__gc;
    var d = { c: -1, s: -1, n: 0, single: true, v: [] };
    var el = card.querySelector('[data-ttd-gc-json]');
    try { if (el) d = JSON.parse(el.textContent); } catch (e) {}
    var active = card.querySelector('.ttd-gc__sw.is-active');
    d.color = active ? active.getAttribute('data-ttd-gc-color') : null;
    card.__gc = d;
    return d;
  }

  function variantsFor(d) {
    if (d.c < 0 || d.color === null) return d.v;
    return d.v.filter(function (v) { return v.o[d.c] === d.color; });
  }

  function build(card) {
    var wrap = card.querySelector('[data-ttd-gc-sizes]');
    if (!wrap) return;
    var d = data(card);
    if (card.__gcBuilt === d.color && wrap.innerHTML) return;
    var html = '';
    var vs = variantsFor(d);
    var anyAvail = vs.some(function (v) { return v.a; });

    card.classList.remove('is-qa-wide');
    if (d.n > 2) {
      card.classList.add('is-qa-wide');
      html = '<button type="button" class="ttd-gc__size ttd-gc__size--wide" data-quick-view data-handle="' +
        esc(card.getAttribute('data-handle')) + '" data-url="' + esc(card.getAttribute('data-url')) + '">Choose options</button>';
    } else if (!anyAvail) {
      card.classList.add('is-qa-wide');
      html = '<span class="ttd-gc__size ttd-gc__size--wide is-out">Sold out in this colour</span>';
    } else if (d.s < 0) {
      var pick = vs.filter(function (v) { return v.a; })[0];
      card.classList.add('is-qa-wide');
      html = '<button type="button" class="ttd-gc__size ttd-gc__size--wide" data-ttd-gc-add="' + pick.id + '">Add to cart</button>';
    } else {
      vs.forEach(function (v) {
        html += '<button type="button" class="ttd-gc__size' + (v.a ? '' : ' is-out') + '"' +
          (v.a ? ' data-ttd-gc-add="' + v.id + '"' : ' disabled aria-disabled="true"') +
          ' aria-label="Add size ' + esc(v.o[d.s]) + ' to cart' + (v.a ? '' : ' (sold out)') + '">' +
          esc(v.o[d.s]) + '</button>';
      });
    }
    wrap.innerHTML = html;
    card.__gcBuilt = d.color;
  }

  function closeAll(except) {
    document.querySelectorAll('.ttd-gc.is-qa-open').forEach(function (c) {
      if (c === except) return;
      c.classList.remove('is-qa-open');
      var t = c.querySelector('[data-ttd-gc-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  function pickColor(card, sw) {
    var d = data(card);
    d.color = sw.getAttribute('data-ttd-gc-color');
    card.querySelectorAll('.ttd-gc__sw').forEach(function (s) { s.classList.toggle('is-active', s === sw); });
    var vs = variantsFor(d);
    var withImg = vs.filter(function (v) { return v.i; })[0];
    var img = card.querySelector('[data-ttd-gc-img]');
    if (img && withImg) {
      img.removeAttribute('srcset');
      img.src = withImg.i;
      card.classList.add('has-color-pick'); // stop the hover image hiding the chosen colour
    }
    var target = vs.filter(function (v) { return v.a; })[0] || vs[0];
    if (target) {
      var base = (card.getAttribute('data-url') || '').split('?')[0];
      card.querySelectorAll('[data-ttd-gc-link]').forEach(function (a) { a.href = base + '?variant=' + target.id; });
    }
    build(card);
  }

  function add(btn) {
    var id = btn.getAttribute('data-ttd-gc-add');
    if (!id || btn.classList.contains('is-adding')) return;
    var card = btn.closest('.ttd-gc');
    var label = btn.textContent;
    btn.classList.add('is-adding');
    var done = function () {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.innerHTML = '&#10003;';
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.textContent = label;
        if (card) closeAll();
      }, 1400);
    };
    if (typeof window.ttdAddToCart === 'function') {
      window.ttdAddToCart(id, 1, done);
    } else {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: +id, quantity: 1 }) })
        .then(function () { window.location.href = '/cart'; });
    }
  }

  // Build the size bar lazily the first time a card is hovered / focused.
  function warm(e) {
    var card = e.target && e.target.closest ? e.target.closest('.ttd-gc') : null;
    if (card) build(card);
  }
  document.addEventListener('mouseover', warm, { passive: true });
  document.addEventListener('focusin', warm);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var sw = t.closest('[data-ttd-gc-color]');
    if (sw) {
      e.preventDefault();
      pickColor(sw.closest('.ttd-gc'), sw);
      return;
    }

    var toggle = t.closest('[data-ttd-gc-toggle]');
    if (toggle) {
      e.preventDefault();
      var card = toggle.closest('.ttd-gc');
      build(card);
      var open = !card.classList.contains('is-qa-open');
      closeAll(card);
      card.classList.toggle('is-qa-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var addBtn = t.closest('[data-ttd-gc-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      add(addBtn);
      return;
    }

    if (!t.closest('.ttd-gc__qa')) closeAll();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
}());
